import ProjectDetailsTab from './ProjectDetailsTab';
import ProjectMilestonesTab from './ProjectMilestonesTab';
import ProjectSprintsTab from './ProjectSprintsTab';
import ProjectBlockersTab from './ProjectBlockersTab';
import ProjectDiscussionTab from './ProjectDiscussionTab';
import ProjectFeedbackTab from './ProjectFeedbackTab';
import ProjectPaymentsTab from './ProjectPaymentsTab';
import ProjectQATab from './ProjectQATab';
import ProjectChangeRequestsTab from './ProjectChangeRequestsTab';
import ProjectPMOTab from './ProjectPMOTab';
import ProjectClientTab from './ProjectClientTab';
import ProjectBacklogsTab from './ProjectBacklogsTab';
import ProjectIssuesAndUpgradesTab from './ProjectIssuesAndUpgradesTab';
import ProjectClientTicketsTab from './ProjectClientTicketsTab';
import ProjectSettingsTab from './settings/ProjectSettingsTab';
import ProjectCollaborationTab from './ProjectCollaborationTab';
import ProjectSubmissionMemosTab from './ProjectSubmissionMemosTab';
import ProjectTimeLogsTab from './ProjectTimeLogsTab';

export {
    ProjectDetailsTab,
    ProjectMilestonesTab,
    ProjectSprintsTab,
    ProjectBlockersTab,
    ProjectDiscussionTab,
    ProjectFeedbackTab,
    ProjectPaymentsTab,
    ProjectQATab,
    ProjectChangeRequestsTab,
    ProjectPMOTab,
    ProjectClientTab,
    ProjectBacklogsTab,
    ProjectIssuesAndUpgradesTab,
    ProjectClientTicketsTab,
    ProjectCollaborationTab,
    ProjectSubmissionMemosTab,
    ProjectTimeLogsTab,
};

const TAB_MAP = {
    details: ProjectDetailsTab,
    milestones: ProjectMilestonesTab,
    sprints: ProjectSprintsTab,
    blockers: ProjectBlockersTab,
    B: ProjectBlockersTab, // backend may send tab id "B" when blockers feature is enabled
    discussion: ProjectDiscussionTab,
    feedback: ProjectFeedbackTab,
    payments: ProjectPaymentsTab,
    payment: ProjectPaymentsTab, // allow ?tab=payment (singular)
    qa: ProjectQATab,
    client: ProjectClientTab,
    clients: ProjectClientTab,
    'change-requests': ProjectChangeRequestsTab,
    changeRequests: ProjectChangeRequestsTab,
    'completion-requests': ProjectPMOTab,
    completionRequests: ProjectPMOTab,
    pmo: ProjectPMOTab,
    'project-pmo': ProjectPMOTab,
    backlogs: ProjectBacklogsTab,
    backlog: ProjectBacklogsTab,
    'issues-and-upgrades': ProjectIssuesAndUpgradesTab,
    issuesAndUpgrades: ProjectIssuesAndUpgradesTab,
    'client-tickets': ProjectClientTicketsTab,
    clientTickets: ProjectClientTicketsTab,
    settings: ProjectSettingsTab,
    collaboration: ProjectCollaborationTab,
    collaborator: ProjectCollaborationTab,
    collaborators: ProjectCollaborationTab,
    tasks: ProjectSprintsTab,
    task: ProjectSprintsTab,
    phases: ProjectMilestonesTab,
    phase: ProjectMilestonesTab,
    'submission-memos': ProjectSubmissionMemosTab,
    submissionMemos: ProjectSubmissionMemosTab,
    submission_memos: ProjectSubmissionMemosTab,
    'time-logs': ProjectTimeLogsTab,
    timeLogs: ProjectTimeLogsTab,
    time_logs: ProjectTimeLogsTab,
};

export function getTabComponent(tabId) {
    return TAB_MAP[tabId] || ProjectDetailsTab;
}
